export default {
  calendarioPromocional: {
    quantidade_produtos: 'Nenhum produto selecionado | {quantidade} produto selecionado | {quantidade} produtos selecionados',
    quantidade_segmentos: 'Nenhum segmento selecionado | {quantidade} segmento selecionado | {quantidade} segmentos selecionados',
  },
}
